import src from './source';
import * as GlobalUtil from './globalUtil';
import {includes, isEmpty, forIn} from "./common";
import {
    getAssignFieldWithFormula,
    getFieldid,
    getStepType,
    getTriFieldWithFormula
} from "../analyzeUtil";

export const isShowAI = () => {
    return src.globalStore.commonParam.showAI == "1";
}

let scriptContent = "";
export const setScriptContent = (str = "") => {
    if (!isShowAI())
        return;
    scriptContent = str;
}

//字段变更类型 
export const TYPE_MAIN_INIT = "1";        //主表字段初始值加载
export const TYPE_DETAIL_ADDROW = "2";    //添加/生成明细行的默认值
export const TYPE_FIELD_CHANGE = "3";     //手动变更字段
export const TYPE_LINKAGE_SYNC = "4";     //同步联动修改
export const TYPE_LINKAGE_ASYNC = "5";    //异步联动修改
export const TYPE_WFFORM_API = "6";       //通过接口WfForm修改
export const TYPE_WFFORM_FORMULA = "7";     //公式修改
export const CHANGE_FIELD_VALUE = "c_value";    //改变字段值
export const CHANGE_FIELD_VARS = "c_vars";      //改变字段属性

let modifyStep = {};
let stepIndex = 0;

/**
 * 当开启智能分析showAI=1时，记录每个字段变更的详细修改日志
 * 包括加载页面初始值、明细生成行的初始值、手动修改值、联动修改的值、接口修改的值
 */
export const generateStepId = (type, otherinfo = {}) => {
    if (!isShowAI())
        return 0;
    stepIndex++;
    modifyStep[`step_${stepIndex}`] = {
        type: type,
        datas: [],
        otherinfo: otherinfo,
        time: new Date().getTime()
    };
    return stepIndex;
}

export const appendStepDetail = (stepid, fieldMark, type, result = {}) => {
    if (!isShowAI())
        return;
    if (typeof stepid === "undefined" || stepid <= 0 || !modifyStep[`step_${stepid}`])
        return;
    const curStep = modifyStep[`step_${stepid}`];
    curStep.datas.push({fieldMark, type, result});
}

//显示分析页面
export const openAIPage = () => {
    const {commonParam} = src.globalStore;
    const custompage = commonParam.custompage;
    window.WfForm_analyzeData = {
        custompage: {
            jsp: GlobalUtil.generateCustomPageList(),
            js: custompage.jsPage || [],
            css: custompage.cssPage || []
        },
        scriptContent: scriptContent,
        modifyStep: modifyStep,
    }
    window.open(`${window.ecologyContentPath || ''}/spa/workflow/static/index.html#/main/workflow/analyze`);
}


/**
 * 获取指定字段的联动信息
 * @param recordfieldids 指定的字段id
 * @returns {{}}
 */
export const getLinkageInfo = (recordfieldids) => {
    const a = new Date();
    const {layoutStore} = src;
    const {tableInfo} = layoutStore;
    const changeFnObj = WfForm.__propertyChangeFnObj;
    const {
        rowCalCfg,
        fieldSqlCfg,
        fieldMathCfg,
        dataInputCfg,
        fieldDateCfg,
        viewAttrCfg,
        mainCalCfg,
        formulaCfg
    } = layoutStore.linkageCfg;
    let dataSource = [];
    rowCalCfg && forIn(rowCalCfg, (value, key) => {
        key !== 'rowCalAssignInfo' &&
        value.map(item => {
            let trgField = key && typeof key === 'string' ? key.split(",") : key;
            let assignField = item.assignField && typeof item.assignField === 'string' ? item.assignField.split(",") : item.assignField;
            dataSource.push(
                {
                    linkageType: '行规则',          //联动名称
                    trgField: trgField,                  //触发字段
                    assignField: assignField,  //赋值字段
                    otherInfo: item.config,
                }
            )
        })
    });
    mainCalCfg && forIn(mainCalCfg, (value, key) => {
        let trgField = key && typeof key === 'string' ? key.split(",") : key;
        let assignField = value && typeof value === 'string' ? value.split(",") : value;
        dataSource.push(
            {
                linkageType: '列赋值',
                trgField: trgField,
                assignField: assignField,
                otherInfo: '',
            }
        )
    });
    fieldSqlCfg && forIn(fieldSqlCfg, (value, key) => {
        if (key === 'emptyTriField') {
            value.map(item => {
                let assignField = item.assignField && typeof item.assignField === 'string' ? item.assignField.split(",") : item.assignField;
                dataSource.push(
                    {
                        linkageType: 'SQL联动',
                        trgField: '无',
                        assignField: assignField,
                        otherInfo: '',
                    }
                )
            })
        } else {
            value.map(item => {
                let trgField = key && typeof key === 'string' ? key.split(",") : key;
                let assignField = item.assignField && typeof item.assignField === 'string' ? item.assignField.split(",") : item.assignField;
                dataSource.push(
                    {
                        linkageType: 'SQL联动',
                        trgField: trgField,
                        assignField: assignField,
                        otherInfo: '',
                    }
                )
            })
        }
    });
    fieldDateCfg && forIn(fieldDateCfg, (value, key) => {
        value.map(item => {
            let trgField = item.relateFields && typeof item.relateFields === 'string' ? item.relateFields.split(",") : item.relateFields;
            let assignField = item.assignField && typeof item.assignField === 'string' ? item.assignField.split(",") : item.assignField;
            dataSource.push(
                {
                    linkageType: '时间日期计算',
                    trgField: trgField,
                    assignField: assignField,
                    otherInfo: '',
                }
            )
        })
    });

    fieldMathCfg && forIn(fieldMathCfg, (value, key) => {
        value.map(item => {
            let trgField = key && typeof key === 'string' ? key.split(",") : key;
            let assignField = item.assignField && typeof item.assignField === 'string' ? item.assignField.split(",") : item.assignField;
            dataSource.push(
                {
                    linkageType: '字段赋值',
                    trgField: trgField,
                    assignField: assignField,
                    otherInfo: item.config,
                }
            )
        })
    });
    dataInputCfg && forIn(dataInputCfg, (value, key) => {
        value.map(item => {
            item.otherParams.assignfields.map(field => {
                let trgField = key && typeof key === 'string' ? key.split(",") : key;
                let assignField = field && typeof field === 'string' ? field.split(",") : field;
                dataSource.push(
                    {
                        linkageType: '字段联动',
                        trgField: trgField,
                        assignField: assignField,
                        otherInfo: item.config,
                    }
                )
            })
        })
    });
    viewAttrCfg && forIn(viewAttrCfg, (value, key) => {
        let fieldArr = [];
        let trgField0 = key.slice(0, -2);
        value.relateFields && value.relateFields.map(item => {
            fieldArr.push(item.slice(0, -2));
        })
        let trgField = trgField0 && typeof trgField0 === 'string' ? trgField0.split(",") : trgField0;
        dataSource.push(
            {
                linkageType: '显示属性联动',
                trgField: trgField,
                assignField: fieldArr,
                otherInfo: '',
            }
        )
    });
    tableInfo && forIn(tableInfo, formInfo => {
        formInfo.fieldinfomap && forIn(formInfo.fieldinfomap, (value, key) => {
            if (value.htmltype == 5 && value.selectattr.childfieldid > 0) {
                let trgField = key && typeof key === 'string' ? key.split(",") : key;
                let temp = value.selectattr.childfieldid.toString();
                let assignField = temp && typeof temp === 'string' ? temp.split(",") : temp;
                dataSource.push(
                    {
                        linkageType: '选择框联动',
                        trgField: trgField,
                        assignField: assignField,
                        otherInfo: '',
                    }
                )
            }
        })
    })
    changeFnObj && forIn(changeFnObj, (v, key) => {
        let trgField = key && typeof key === 'string' ? key.split(",") : key;
        dataSource.push(
            {
                linkageType: '代码块/自定义页面',
                trgField: trgField,
                assignField: '',
                otherInfo: v.length + '条',
            }
        )
    });

    formulaCfg && forIn(formulaCfg, (value, key) => {
        if (key === 'formulas') {
            value.map(item => {
                let triFields = getTriFieldWithFormula(item.triggers);
                let destfield = getAssignFieldWithFormula(item.destfield);
                let assignField = destfield && typeof destfield === 'string' ? destfield.split(",") : destfield;
                dataSource.push({
                    linkageType: '公式',
                    trgField: triFields,
                    assignField: assignField,
                    otherInfo: ''
                })
            })
        }
    })

    let cfjMap = {};
    recordfieldids.map(fieldid => {
        cfjMap[fieldid] = dataSource.filter(item => {
            // let trgFieldArr = item.trgField;
            // let assignFieldArr = item.assignField;
            let reactionFieldArr = item.trgField.concat(item.assignField);
            let flag = false;
            for (let i = 0; i < reactionFieldArr.length; i++) {
                if (reactionFieldArr[i] === fieldid) {
                    flag = true;
                    break;
                }
            }
            return flag;
        });
    })

    return cfjMap;
}


/**
 * 获取目标字段所有的变更步骤
 * @param fieldId
 */
export const getFieldStepALLInfo = (fieldId) => {
    let dataSource = [];
    let {htmltype} = wfform.getFieldInfo(fieldId);
    modifyStep && forIn(modifyStep, (value, key) => {
        let rowData = {};
        let step = key.substring(5);
        let type = value.type;
        let changedDatas = value.datas;
        let linkageInfo = value.otherinfo;
        rowData["key"] = step;
        rowData["step"] = step;
        rowData["type"] = getStepType(type);
        isEmpty(linkageInfo) ? null : rowData["linkageInfo"] = linkageInfo; //联动信息
        isEmpty(changedDatas) ? null : rowData["changedDatas"] = changedDatas; //变更数据
        dataSource.push(rowData);
    });

    //根据字段查询
    let fieldList = fieldId ? fieldId.split(",") : [];
    let resArr = fieldList.length === 0 ? null : dataSource.filter(item => {
        let newChangedDatas = [];
        newChangedDatas = item.changedDatas && item.changedDatas.filter(o => {
            return includes(fieldList, getFieldid(o.fieldMark));
        });
        if ((htmltype === 1 || htmltype === 2) && typeof newChangedDatas != 'undefined') {
            for (let i = 0; i < newChangedDatas.length; i++) {
                //排除改变类型为字段属性变更的情况
                if (newChangedDatas[i].type !== CHANGE_FIELD_VARS) {
                    let stepValue = newChangedDatas[i].result.value;
                    newChangedDatas[i].result.value = stepValue.length > 100 ? stepValue.substr(0, 100) + "...(文本超长部分已被截取)" : stepValue;
                }
            }
        }
        item.changedDatas = newChangedDatas;
        return item.changedDatas && item.changedDatas.length > 0;
    });

    return resArr;
}

/**
 * 获取目标字段的第一步和最后两步变更数据，明细表需要获取目标列每一行的对应字段的第一步和最后两步数据
 * @param fieldId
 */
export const getFieldStepInfo = (fieldId) => {
    let res = [];
    const fieldAllSteps = getFieldStepALLInfo(fieldId);
    const {isdetail, tableMark} = wfform.getFieldInfo(fieldId);

    if (isdetail) {
        //第一步：按照下标过滤明细数据
        let rows = parseInt(wfform.getDetailRowCount(tableMark));
        let indexArr = [];
        if (rows > 10) {
            for (let i = 0; i < 10; i++) {
                let indexStepData1 = {detailIndex: i, detailFieldSetp: []};
                for (let j = 0; j < fieldAllSteps.length; j++) {
                    let index1 = parseInt(fieldAllSteps[j].changedDatas[0].fieldMark.split("_")[1]);
                    if (index1 === i) {
                        indexStepData1.detailFieldSetp.push(fieldAllSteps[j]);
                    }
                }
                indexArr.push(indexStepData1);
            }
        } else {
            for (let x = 0; x < rows; x++) {
                let indexStepData2 = {detailIndex: x, detailFieldSetp: []};
                for (let y = 0; y < fieldAllSteps.length; y++) {
                    let index2 = parseInt(fieldAllSteps[y].changedDatas[0].fieldMark.split("_")[1]);
                    if (index2 === x) {
                        indexStepData2.detailFieldSetp.push(fieldAllSteps[y]);
                    }
                }
                indexArr.push(indexStepData2);
            }
        }

        //第二部：过滤出对应明细行目标字段的第一步和最后两步变更数据
        for (let z = 0; z < indexArr.length; z++) {
            if (indexArr[z].detailFieldSetp.length > 3) {
                let tempArr1 = [];
                tempArr1.push(indexArr[z].detailFieldSetp[0]);
                tempArr1.push(indexArr[z].detailFieldSetp[indexArr[z].detailFieldSetp.length - 2]);
                tempArr1.push(indexArr[z].detailFieldSetp[indexArr[z].detailFieldSetp.length - 1]);
                indexArr[z].detailFieldSetp = tempArr1;
            }
        }

        res = indexArr;
        return res;
    } else {
        //主表字段的数据过滤，取第一步和最后两步的数据
        if (fieldAllSteps.length > 3) {
            res.push(fieldAllSteps[0]);
            res.push(fieldAllSteps[fieldAllSteps.length - 2]);
            res.push(fieldAllSteps[fieldAllSteps.length - 1]);
        } else {
            res = fieldAllSteps;
        }
    }
    return res;
}

/**
 * 获取表单加载时字段的值
 */
export const getFirstStepData = (stepInfo, isDetail) => {
    if (isDetail) {
        //最多取前10行明细对应列字段的加载时数据
        let res = [];
        for (let i = 0; i < stepInfo.length; i++) {
            let detailSteps = stepInfo[i].detailFieldSetp.length;
            if (detailSteps > 0) {
                res.push({
                    detailIndex: stepInfo[i].detailIndex,
                    firstStep: stepInfo[i].detailFieldSetp[0].changedDatas[0].result.value
                })
            } else {
                res.push({
                    detailIndex: stepInfo[i].detailIndex,
                    firstStep: "无变更步骤数据"
                })
            }
        }
        return res;
    } else {
        //主表字段
        if (stepInfo.length > 0) {
            //区分值改变和字段属性改变
            if (stepInfo[0].changedDatas[0].type === CHANGE_FIELD_VARS) {
                return stepInfo[0].changedDatas[0].result.viewAttr;
            } else {
                return stepInfo[0].changedDatas[0].result.value;
            }
        } else {
            return "无变更步骤数据";
        }
    }
}


/**
 * 获取表单提交时字段的值
 */
export const getLastStepData = (stepInfo, isDetail) => {
    if (isDetail) {
        //最多取前10行明细对应列字段的加载时数据
        let res = [];
        for (let i = 0; i < stepInfo.length; i++) {
            let detailSteps = stepInfo[i].detailFieldSetp.length;
            if (detailSteps > 0) {
                res.push({
                    detailIndex: stepInfo[i].detailIndex,
                    firstStep: stepInfo[i].detailFieldSetp[detailSteps - 1].changedDatas[0].result.value
                })
            } else {
                res.push({
                    detailIndex: stepInfo[i].detailIndex,
                    firstStep: "无变更步骤数据"
                })
            }
        }
        return res;
    } else {
        //主表字段
        if (stepInfo.length > 0) {
            //区分值改变和字段属性改变
            if (stepInfo[stepInfo.length - 1].changedDatas[0].type === CHANGE_FIELD_VARS) {
                return stepInfo[stepInfo.length - 1].changedDatas[0].result.viewAttr;
            } else {
                return stepInfo[stepInfo.length - 1].changedDatas[0].result.value;
            }
        } else {
            return "无变更步骤数据";
        }
    }
}





// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/util/public/analyzeData.js